<p (click)="navigate()" class="light back-to-event-button">
  Back to event
</p>
